import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

import { PopoverListItem } from '@/components/elements'

type Props = ComponentPropsWithoutRef<typeof PopoverListItem>

export const AuthUserPopoverListItem: FC<Props> = ({ className, ...props }) => {
  return (
    <PopoverListItem {...props} className={clsx(['pl-6 pr-4', className])} />
  )
}
